import { App } from 'vue';
import Modal from '~/components/modals/modal-prompt.vue';

export default {
    install(app: App) {
        app.component('modal-prompt', Modal);
        app.config.globalProperties.$prompt = function(title: string, options: Record<string,string|number>): Promise<string> {
            return new Promise<string>((resolve) => {
                // listen to submit event to resolve promise
                app.config.globalProperties.$eventBus.on('prompt.submit', (result: string) => resolve(result));
                // listen to close event to resolve promise in case user cancel prompt
                app.config.globalProperties.$eventBus.on('prompt.close', () => resolve(null));
                // open modal
                app.config.globalProperties.$eventBus.emit('prompt.open', { title, options });
            }).finally(() => {
                // clean events listeners
                app.config.globalProperties.$eventBus.off('prompt.submit');
                app.config.globalProperties.$eventBus.off('prompt.close');
            })
        }
    }
}